import {
  Button,
  Checkbox,
  Icon,
  Menu,
  MenuButton,
  MenuDivider,
  MenuItem,
  MenuList,
  Portal,
  Text,
  Th,
} from '@chakra-ui/react';
import { MdFilterAlt, MdOutlineFilterAlt } from 'react-icons/md';

interface ColumnFilterHeaderProps {
  label: string;
  options: { value: string; label: string }[];
  selected: string[];
  onChange: (values: string[]) => void;
}

const ColumnFilterHeader = ({
  label,
  options,
  selected,
  onChange,
}: ColumnFilterHeaderProps) => {
  const isActive = selected.length > 0;

  return (
    <Th pe="10px" color="gray.400">
      <Menu closeOnSelect={false} isLazy>
        <MenuButton
          as={Button}
          variant="unstyled"
          size="xs"
          h="auto"
          fontSize="inherit"
          fontWeight="inherit"
          textTransform="inherit"
          letterSpacing="inherit"
          color={isActive ? 'brand.500' : 'inherit'}
          rightIcon={
            <Icon
              as={isActive ? MdFilterAlt : MdOutlineFilterAlt}
              boxSize={3.5}
            />
          }
          isDisabled={options.length === 0}
        >
          {label}
        </MenuButton>
        <Portal>
          <MenuList maxH="300px" overflowY="auto" fontSize="sm">
            {options.map((o) => {
              const isChecked = selected.includes(o.value);
              return (
                <MenuItem
                  key={o.value}
                  gap={3}
                  px={4}
                  py={2}
                  onClick={() =>
                    onChange(
                      isChecked
                        ? selected.filter((v) => v !== o.value)
                        : [...selected, o.value],
                    )
                  }
                >
                  <Checkbox
                    isChecked={isChecked}
                    colorScheme="blue"
                    pointerEvents="none"
                  />
                  <Text>{o.label}</Text>
                </MenuItem>
              );
            })}
            <MenuDivider />
            <MenuItem onClick={() => onChange([])} isDisabled={!isActive}>
              Clear filter
            </MenuItem>
          </MenuList>
        </Portal>
      </Menu>
    </Th>
  );
};

export default ColumnFilterHeader;
